module.exports = __webpack_public_path__ + "img/artboard_bk_book.90708470.png";